import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";
import OrganizationIndexTreeMapper from "../service/OrganizationIndexTreeMapper";

export default class GetHarmonizedIndexTreeInteractor {
  private resource: FindResourceEntryInteractor<IOrganisationIndexGroup[]>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(categoryTypeId: number) {
    return this.resource.execute(
      `organisations/index-categories`,
      OrganizationIndexTreeMapper,
      () => {},
      categoryTypeId
    );
  }
}
